import {classNames} from '@cohort/shared-frontend/utils/classNames';
import SvgIcon from '@cohort/wallet/components/Svg';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {DigitalAssetTransferInvitationWDto} from '@cohort/wallet-schemas/ownership';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

interface NftTransferSenderMessageProps {
  nftTransferInvitation?: DigitalAssetTransferInvitationWDto;
}

export const NftTransferSenderMessage: React.FC<NftTransferSenderMessageProps> = ({
  nftTransferInvitation,
}) => {
  const {hasDarkBg} = useThemeContext();
  const {t} = useTranslation('components', {
    keyPrefix: 'space.nftTransfer.nftTransferSenderMessage',
  });

  if (
    nftTransferInvitation === undefined ||
    nftTransferInvitation.message === null ||
    nftTransferInvitation.message.length === 0
  ) {
    return <Fragment />;
  }

  return (
    <div
      className={classNames(
        'mt-5 flex w-full flex-col rounded-lg p-5 md:flex-row md:space-x-5',
        hasDarkBg ? 'bg-white/5' : 'bg-black/5'
      )}
    >
      <SvgIcon
        className="my-auto hidden md:block"
        color={hasDarkBg ? '#FFFFFF40' : '#00000040'}
        name="Quote"
        height={20}
      />
      <div>
        <SvgIcon
          className="mx-auto mb-3 md:hidden"
          color={hasDarkBg ? '#FFFFFF40' : '#00000040'}
          name="Quote"
          height={20}
        />
        <div
          data-testid="invitation-message"
          className={classNames(
            'break-all text-center md:text-left',
            hasDarkBg ? 'text-white' : 'text-black'
          )}
        >
          {t('acceptNftMessageFrom', {senderEmail: nftTransferInvitation.senderEmail})}
        </div>
        <div
          className={classNames(
            'space-x-5 text-center text-sm leading-5 md:text-left',
            hasDarkBg ? 'text-white/70' : 'text-black/70'
          )}
        >
          {nftTransferInvitation.message}
        </div>
      </div>
    </div>
  );
};

NftTransferSenderMessage.displayName = 'NftTransferSenderMessage';
